/* eslint react/prop-types: 0 */
import React from 'react';
import { injectIntl } from 'react-intl';
import './boardModals.scss';

/**
 * Lo que ve el usuario cuando la placa que acaba de vincular no tiene el firmware
 * de trazabilidad, o tiene uno anterior al número de producción.
 *
 * No se puede cerrar y no ofrece seguir sin instalar. Antes ofrecía "más tarde",
 * cuando el firmware era un extra; ahora es de donde sale la identidad de la
 * placa, así que posponerlo dejaría a la placa sin poder identificarse y al
 * usuario con la misma pregunta en la próxima pantalla. Lo único que se puede
 * hacer acá es instalarlo, y si falla, volver a intentarlo.
 *
 * Usa las mismas clases que los demás modales del panel -- `short-modal` y los
 * botones de bootstrap -- para que el tema, los tamaños y los botones salgan de
 * donde salen siempre y no haya que mantener un estilo aparte.
 *
 * Lo que sí es distinto es que se muestra y se esconde desde el estado de React y
 * no con jQuery, así el componente se puede usar en cualquier lado sin depender
 * del $ global ni de un id de bootstrap. Por eso las clases `show` y el display
 * van puestos a mano: son los que normalmente pone el plugin.
 */
const InstallFirmwareModal = ({ open, installing, failed, intl, onInstall }) => {
  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop show" />
      <div
        className="modal fade show installFirmwareModal short-modal"
        role="dialog"
        aria-modal="true"
        style={{ display: 'block' }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {intl.formatMessage({ id: 'blocks.blockly.installFirmwareModal.title' })}
              </h5>
            </div>
            <div className="modal-body">
              <img src="/images/web_serial/linking.png" width="72" alt="" />
              <p className="message">{intl.formatMessage({ id: 'blocks.blockly.installFirmwareModal.message' })}</p>
              <p className="detail">
                {failed && !installing
                  ? intl.formatMessage({ id: 'blocks.blockly.installFirmwareModal.error' })
                  : intl.formatMessage({ id: 'blocks.blockly.installFirmwareModal.detail' })}
              </p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary main-btn" onClick={onInstall} disabled={installing}>
                {(() => {
                  if (installing) return intl.formatMessage({ id: 'blocks.blockly.installFirmwareModal.installing' });
                  if (failed) return intl.formatMessage({ id: 'blocks.blockly.installFirmwareModal.retry' });
                  return intl.formatMessage({ id: 'blocks.blockly.installFirmwareModal.install' });
                })()}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default injectIntl(InstallFirmwareModal);
